import { get } from '@/api/httpRequests'
import { BOOTSTRAP } from '@/api/streemiq/apiConstantsStreemIQ'
import { getErrorMessage } from '@/shared/lib'
import {
    bootstrapsKeyword,
    saveToLocalStorage,
} from '@/shared/localStorage/localStorageRepository'

export async function fetchBootstraps() {
    try {
        const response = await get(BOOTSTRAP, true)

        if (response.jsonData) {
            const { jsonData: bootstraps } = response

            saveToLocalStorage(
                bootstrapsKeyword,
                JSON.stringify(bootstraps.resources[0])
            )
            return bootstraps.resources[0]
        }
    } catch (error) {
        getErrorMessage('fetchBootstraps', error)
        throw error
    }
}
